function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from 'react';
import { calcLoopedSlides } from '../shared/calc-looped-slides.js';
function renderLoop(swiper, slides, swiperParams) {
    var modifiedSlides = slides.map(function(child, index) {
        return /*#__PURE__*/ React.cloneElement(child, {
            swiper: swiper,
            'data-swiper-slide-index': index
        });
    });
    function duplicateSlide(child, index, position) {
        return /*#__PURE__*/ React.cloneElement(child, {
            key: "".concat(child.key, "-duplicate-").concat(index, "-").concat(position),
            className: "".concat(child.props.className || '', " ").concat(swiperParams.slideDuplicateClass)
        });
    }
    if (swiperParams.loopFillGroupWithBlank) {
        var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;
        if (blankSlidesNum !== swiperParams.slidesPerGroup) {
            for(var i = 0; i < blankSlidesNum; i += 1){
                var blankSlide = /*#__PURE__*/ React.createElement("div", {
                    className: "".concat(swiperParams.slideClass, " ").concat(swiperParams.slideBlankClass)
                });
                modifiedSlides.push(blankSlide);
            }
        }
    }
    if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
        swiperParams.loopedSlides = modifiedSlides.length;
    }
    var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
    var prependSlides = [];
    var appendSlides = [];
    for(var i1 = 0; i1 < loopedSlides; i1 += 1){
        var index = i1 - Math.floor(i1 / modifiedSlides.length) * modifiedSlides.length;
        appendSlides.push(duplicateSlide(modifiedSlides[index], i1, 'append'));
        prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index - 1], i1, 'prepend'));
    }
    if (swiper) {
        swiper.loopedSlides = loopedSlides;
    }
    return _to_consumable_array(prependSlides).concat(_to_consumable_array(modifiedSlides), _to_consumable_array(appendSlides));
}
export { calcLoopedSlides, renderLoop };
